module.exports = __webpack_public_path__ + "ac72fe0f27dd514aa3215e8424842062.ttf";